export const getGoogleMapsEmbedUrl = (query: string, zoom = 15) => {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_EMBED_API_KEY as
    | string
    | undefined

  if (import.meta.env.VITE_ENABLE_GOOGLE_MAPS_EMBED === "true" && apiKey) {
    return `https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(apiKey)}&q=${query}&zoom=${zoom}`
  }

  return `https://www.google.com/maps?q=${query}&z=${zoom}&output=embed`
}

// Google's documented "search" URL form. maps.google.com/?q=... still works but
// is the legacy shape and appeared in three different encodings across the
// site; api=1 is the one Google supports and documents.
// `query` must already be URI-encoded, matching getGoogleMapsEmbedUrl.
export function getGoogleMapsSearchUrl(query: string) {
  return `https://www.google.com/maps/search/?api=1&query=${query}`
}
